import { createContext, useContext } from 'react'

export interface PreviewEnvironment {
  scrapeLinks: boolean
  readComposerStores: boolean
}

const PreviewEnvironmentContext = createContext<PreviewEnvironment>({
  scrapeLinks: true,
  readComposerStores: true,
})

export const PreviewEnvironmentProvider = PreviewEnvironmentContext.Provider

export function usePreviewEnvironment(): PreviewEnvironment {
  return useContext(PreviewEnvironmentContext)
}
